import BundleWidget from 'components/ProductPage/PdpBundling/BundleWidget/BundleWidget';

export default BundleWidget;
